<p [style.fontSize]="field.templateOptions.extraData?.styles?.labelTextSize"><strong [innerHtml]="field.templateOptions.label"></strong></p>
<span [innerHTML]="field.templateOptions.description"></span>